<template lang="pug">
  div.schema-input
    component(
      :is="propertyAndComponent.component"
      v-for="(propertyAndComponent, index) in components"
      :key="index"
      :data="values[propertyAndComponent.property]"
      :property="properties[propertyAndComponent.property]"
      :propertyName="propertyAndComponent.property"
      :disabled="disabled"
      :mappings="mappings"
      :default="properties[propertyAndComponent.property].default"
      :required="schema.required ? schema.required.includes(propertyAndComponent.property) : false",
      @update:data="update(propertyAndComponent.property, arguments[0], arguments[1])")
</template>

<script>
export default {
  name: 'ObjectInput',
  props: {
    mappings: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    metadata: {
      required: false
    },
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      properties: null,
      components: [],
      values: this.metadata || {}
    }
  },
  methods: {
    update(prop, value, isValid) {
      this.components.find((c) => c.propertyName === prop).isValid = isValid
      const invalidComponents = this.components.filter((c) => !c.isValid)
      const defaultValue = typeof value === 'boolean' && value === false ? false : undefined
      this.values[prop] = value || defaultValue
      this.$emit('update:data', this.values, invalidComponents.length === 0)
    },
  },
  mounted() {
    this.properties = this.schema.properties
    Object.keys(this.properties).forEach((prop) => {
      const mapping = this.mappings.find((m) => m.accepts(this.properties[prop]))
      if (mapping) {
        this.components.push({
          propertyName: prop, property: prop, isValid: false, component: () => Promise.resolve(mapping)
        })
      } else {
        this.components.push({
          propertyName: prop, property: prop, isValid: false, component: () => import('./Default')
        })
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/ObjectInput.vue